import axios from "axios";

const registerLegalPartner = async (data) => {
  const url = `/api/register-legal-partner/`;

  const headers = {
    "Content-Type": "application/json",
  };

  let response;
  try {
    response = await axios.post(url, data, headers);
  } catch (error) {
    return Promise.reject(error);
  }

  return response;
};

export default registerLegalPartner;
